import { Buffer } from 'buffer';
import process from 'process';
import { EventEmitter } from 'events';

if (typeof globalThis.Buffer === 'undefined') {
  globalThis.Buffer = Buffer;
}

if (typeof globalThis.process === 'undefined') {
  globalThis.process = process;
}

if (typeof globalThis.EventEmitter === 'undefined') {
  globalThis.EventEmitter = EventEmitter;
}

if (typeof window !== 'undefined' && typeof window.global === 'undefined') {
  window.global = window;
}

if (typeof window !== 'undefined' && typeof window.module === 'undefined') {
  window.module = {
    exports: {}
  };
}